import React, { FC, useMemo, useState } from "react";
import Codemirror, {
  BasicSetupOptions,
  Extension,
  ReactCodeMirrorRef,
} from "@uiw/react-codemirror";
import { EditorView } from "@codemirror/view";
import { githubLight } from "@uiw/codemirror-theme-github";
import { Button, Modal } from "antd";

import styles from "./index.less";

import { ReactComponent as FullscreenIcon } from "../../../../assets/fullscreen.svg";

type SupportedLanguage = "python";

const DEFAULT_BASIC_SETUP: BasicSetupOptions = {
  lineNumbers: true,
  closeBrackets: false,
};

export interface BasicEditorProps {
  ref?: React.RefObject<ReactCodeMirrorRef>;
  value?: string;
  onChange: (v: string) => void;
  placeholder?: string;
  language: SupportedLanguage;
  extensions?: Extension[];
  extendComponents?: React.ReactElement[];
  basicSetup?: BasicSetupOptions;
}

/**
 * 基本编辑器
 * @returns
 */
const BasicEditor: FC<BasicEditorProps> = ({
  ref,
  value = "",
  onChange,
  placeholder = "",
  extensions,
  extendComponents,
  basicSetup = DEFAULT_BASIC_SETUP,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const allExtensions = useMemo(
    () => [EditorView.lineWrapping, ...(extensions ?? [])],
    [extensions]
  );

  return (
    <div className={styles["editor-container"]}>
      <Codemirror
        height="200px"
        className={styles.codemirror}
        ref={ref}
        value={value}
        theme={githubLight}
        onChange={onChange}
        basicSetup={basicSetup}
        extensions={allExtensions}
        placeholder={placeholder}
      />
      <div className={styles["editor-actions"]}>
        <Button
          type="text"
          icon={<FullscreenIcon />}
          onClick={() => {
            setOpen(true);
          }}
        />
      </div>

      <Modal
        width={700}
        open={open}
        title="编辑器"
        destroyOnClose
        onOk={() => {
          setOpen(false);
        }}
        footer={[]}
        classNames={{
          body: styles["editor-modal-body"],
          footer: styles["editor-modal-footer"],
        }}
        onCancel={() => setOpen(false)}
      >
        <Codemirror
          height="500px"
          className={styles.codemirror}
          value={value}
          theme={githubLight}
          onChange={onChange}
          basicSetup={basicSetup}
          extensions={allExtensions}
          placeholder={placeholder}
        />
      </Modal>

      {/* 额外的组件 */}
      {extendComponents}
    </div>
  );
};

export default BasicEditor;
